// extracted by mini-css-extract-plugin
export var video = "recipe-video-preview-module--video--h013M";
export var videoPreview = "recipe-video-preview-module--video-preview--HSzCz";